module.exports = __webpack_public_path__ + "img/card-billing-history.55b303ea.svg";